import { PreviewSecretContext } from '@dreamstack/artemis'
import { NotificationContextProvider } from '@dreamstack/feature-components/src/notification/NotificationContext'
import { NotificationHub } from '@dreamstack/feature-components/src/notification/NotificationHub'
import { SeoDefaults } from '@dreamstack/seo'
// import { ThemeProvider } from './ThemeProvider'
import { GlobalStyles, ThemeProvider } from '@dreamstack/theme'
import { GoogleAnalyticsContextProvider } from '@dreamstack/tracking'
import type { FunctionComponent } from 'react'
import { NEXT_PUBLIC_GOOGLE_ANALYTICS_ID } from '../config/env'

export const MainProvider: FunctionComponent<
  React.PropsWithChildren<{ pageProps: any }>
> = ({ children, pageProps }) => {
  return (
    <>
      <ThemeProvider>
        <SeoDefaults siteTitle="Accentro International" />
        <GlobalStyles />
        <PreviewSecretContext.Provider
          value={{ previewModeSecret: pageProps.previewModeSecret }}
        >
          <GoogleAnalyticsContextProvider
            trackingId={NEXT_PUBLIC_GOOGLE_ANALYTICS_ID}
          >
            <NotificationContextProvider>
              <NotificationHub />
              <>{children}</>
            </NotificationContextProvider>
          </GoogleAnalyticsContextProvider>
        </PreviewSecretContext.Provider>
      </ThemeProvider>
    </>
  )
}
